import { AxiosError } from 'axios';
import { HttpStatus } from '../constants/http-status';
import { createBackendErrorTranslationKey } from '../utils/error-translation-helpers';
import { showErrorToast } from '../utils/toasts';

export const ERROR_CODES_TO_HANDLE = [
  HttpStatus.BAD_REQUEST,
  HttpStatus.FORBIDDEN,
  HttpStatus.NOT_FOUND,
  HttpStatus.INTERNAL_SERVER_ERROR,
  HttpStatus.BAD_GATEWAY,
  HttpStatus.SERVICE_UNAVAILABLE,
  HttpStatus.UNPROCESSABLE_CONTENT,
];

type showApiErrorToastProps = {
  apiRoute?: string;
} & AxiosError;

export const showApiErrorToast = ({ error }: { error: showApiErrorToastProps }) => {
  const { status } = error.response || {};
  const backEndErrorTranslationKey = createBackendErrorTranslationKey(error);
  const httpStatusErrorTranslationKey = `error:http-status:${status}`;

  showErrorToast({
    error: backEndErrorTranslationKey,
    fallbackError: httpStatusErrorTranslationKey,
    caller: 'errorsHandlingInterceptor',
    xAmznTraceId: error.response?.headers['x-amzn-trace-id'],
    xAmznRequestId: error.response?.headers['x-amzn-requestid'],
    apiRoute: error.config.url,
    data: error.config.data ? JSON.stringify(error.config.data) : undefined,
    headers: error.config.headers ? JSON.stringify(error.config.headers) : undefined,
  });
};

/**
 * This error handler is not helping us at all.
 * Since errors should handled in each component to display relevant error message to users.
 * */
export const errorsHandlingInterceptor = (error: AxiosError): void => {
  // Removed console.log({ error }) as it creates unhelpful [object Object] entries in Sentry
  // Detailed error logging is already handled in configure-axios.ts response interceptor

  // To omit error message toast when products json endpoint is used. Should be refactored.
  // TODO : https://petsdeli.atlassian.net/browse/PT-2262
  if (error.config.url && error.config.url.indexOf('/products/') > -1) {
    throw error;
  }

  // Hot fix : just surpress error message. we need to deal with it properly later.
  // TODO : https://petsdeli.atlassian.net/browse/PT-2919
  if (error.config.url && error.config.url.indexOf('/close/') > -1) {
    throw error;
  }

  const { status } = error.response || {};
  const { errorHandling } = error.config;

  const { statusesToOmit = [], omit } = errorHandling || {};
  const shouldOmit = omit ? omit(error) : false;

  // 401 error should be handled respectively based on situation.
  // Not sure if we need this sloppy implementation.
  // if (!shouldOmit && status === HttpStatus.UNAUTHORIZED) {
  //   customerLocalStorageItemsCleanup();
  //   // setTimeout(() => window.location.reload(), 0);
  //   throw error;
  // }

  if (
    !shouldOmit &&
    status &&
    !statusesToOmit.includes(status) &&
    ERROR_CODES_TO_HANDLE.includes(status)
  ) {
    showApiErrorToast({ error });
  }

  throw error;
};
